export default __webpack_public_path__ + "static/media/attach2.88467198.svg";